// Power units data for conversion routes
// Base unit: watt (W)

export const powerUnits = [
  { id: 'watt', name: 'Watt', symbol: 'W', plural: 'Watts', factor: 1 },
  { id: 'kilowatt', name: 'Kilowatt', symbol: 'kW', plural: 'Kilowatts', factor: 1000 },
  { id: 'megawatt', name: 'Megawatt', symbol: 'MW', plural: 'Megawatts', factor: 1000000 },
  { id: 'gigawatt', name: 'Gigawatt', symbol: 'GW', plural: 'Gigawatts', factor: 1000000000 },
  { id: 'milliwatt', name: 'Milliwatt', symbol: 'mW', plural: 'Milliwatts', factor: 0.001 },
  { id: 'horsepower', name: 'Horsepower (mechanical)', symbol: 'hp', plural: 'Horsepower', factor: 745.7 },
  { id: 'horsepower-metric', name: 'Horsepower (metric)', symbol: 'PS', plural: 'Metric horsepower', factor: 735.49875 },
  { id: 'btu-per-hour', name: 'BTU per hour', symbol: 'BTU/h', plural: 'BTU per hour', factor: 0.29307107 },
  { id: 'foot-pound-per-second', name: 'Foot-pound per second', symbol: 'ft·lb/s', plural: 'Foot-pounds per second', factor: 1.355818 },
  { id: 'calorie-per-second', name: 'Calorie per second', symbol: 'cal/s', plural: 'Calories per second', factor: 4.184 },
  { id: 'kilocalorie-per-hour', name: 'Kilocalorie per hour', symbol: 'kcal/h', plural: 'Kilocalories per hour', factor: 1.163 },
];

// Popular conversions matching common usage
export const popularPowerConversions = [
  { from: 'kilowatt', to: 'horsepower' },
  { from: 'horsepower', to: 'kilowatt' },
  { from: 'watt', to: 'kilowatt' },
  { from: 'kilowatt', to: 'watt' },
  { from: 'horsepower', to: 'watt' },
  { from: 'watt', to: 'horsepower' },
  { from: 'megawatt', to: 'kilowatt' },
  { from: 'kilowatt', to: 'megawatt' },
  { from: 'btu-per-hour', to: 'watt' },
  { from: 'watt', to: 'btu-per-hour' },
  { from: 'horsepower', to: 'horsepower-metric' },
  { from: 'horsepower-metric', to: 'horsepower' },
  { from: 'kilowatt', to: 'btu-per-hour' },
  { from: 'btu-per-hour', to: 'kilowatt' },
  { from: 'gigawatt', to: 'megawatt' },
  { from: 'megawatt', to: 'gigawatt' },
];

// Get unit by ID
export const getUnitById = (id) => {
  return powerUnits.find(unit => unit.id === id);
};

// Convert between units
export const convertPower = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;

  const watts = value * fromUnit.factor;
  return watts / toUnit.factor;
};

// Format conversion slug to readable text
export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

// Generate SEO description
export const generateSEODescription = (fromUnit, toUnit) => {
  const sampleValue = 1;
  const result = convertPower(sampleValue, fromUnit.id, toUnit.id);
  const formattedResult = result < 0.001 || result > 1000000
    ? result.toExponential(4)
    : result.toPrecision(6).replace(/\.?0+$/, '');

  return `Convert ${fromUnit.plural} to ${toUnit.plural}. 1 ${fromUnit.name} = ${formattedResult} ${toUnit.plural}. Free online power unit converter.`;
};
